import { render } from "./Results12.vue?vue&type=template&id=7317cb15&scoped=true"
import script from "./Results12.vue?vue&type=script&lang=js"
export * from "./Results12.vue?vue&type=script&lang=js"

import "./Results12.vue?vue&type=style&index=0&id=7317cb15&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7317cb15"]])

export default __exports__